type ContentT<R> = {
  name: string;
  description?: string;
  content: R;
};

export type ContentText = ContentT<{
  text: (string | { imageRef: string })[];
}>;
export type ContentModel = ContentT<{
  model: {
    configuration: {
      enhancedViewKey: string;
      modifiers: { reference: string[]; visible: boolean }[];
    };
  };
  view?: {
    position: [number, number, number];
    rotation: [number, number, number];
    target: [number, number, number];
  };
}>;

export type ContentItemView = ContentText | ContentModel;

export function isContentText(page: ContentItemView): page is ContentText {
  return 'text' in page.content;
}
export function isContentModel(page: ContentItemView): page is ContentModel {
  return 'model' in page.content;
}
